import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { Reactions } from '..';
import { ReactionsDriver, reactionsDriverFactory } from './Reactions.driver';
import {
  heartItems,
  heartItemsData,
  thumbsUpItemsData,
  thumbsupItems,
} from './fixtures';
import { EditorShell, VisualAsync } from '../../test/visual/VisualAsync';

visualize('Reactions', () => {
  story('simple / focus', () => {
    const its = [
      {
        it: 'click trigger button',
        action: async (driver: ReactionsDriver) => {
          await driver.clickTriggerButton();
        },
      },
      {
        it: 'focus trigger button',
        action: async (driver: ReactionsDriver) => {
          const event = new KeyboardEvent('keydown', { key: 'a' });
          document.dispatchEvent(event);
          await driver.focusTriggerButton();
        },
      },
      {
        it: 'focus sub-trigger button',
        action: async (driver: ReactionsDriver) => {
          const event = new KeyboardEvent('keydown', { key: 'a' });
          document.dispatchEvent(event);
          await driver.focusTriggerButton();
          (await driver.getSubTriggerButton())
            .getNative()
            .then((el) => el.focus());
        },
      },
      {
        it: 'focus reaction list',
        action: async (driver: ReactionsDriver) => {
          const event = new KeyboardEvent('keydown', { key: 'a' });
          document.dispatchEvent(event);
          await driver.focusTriggerButton();
          (await driver.getSubTriggerButton()).click();
        },
      },
    ];
    its.forEach(({ it, action }) =>
      snap(it, (done) => (
        <VisualAsync
          checkered
          driverFactory={reactionsDriverFactory}
          onDone={done}
          action={action}
        >
          <Reactions
            selectedId="thinking"
            onReactionSelect={() => {}}
            additionalReactions={heartItems}
            reactionIcon={(id) => heartItemsData[id].icon}
            reactionLabel={(id) => heartItemsData[id].label}
            defaultReaction="heart"
            popoverTriggerAriaLabel="Reactions"
          />
        </VisualAsync>
      )),
    );
  });
  story('simple', () => {
    snap(
      'default props',
      <EditorShell checkered>
        <div>
          <h2>with heart icon</h2>
          <Reactions
            onReactionSelect={() => {}}
            additionalReactions={heartItems}
            reactionIcon={(id) => heartItemsData[id].icon}
            reactionLabel={(id) => heartItemsData[id].label}
            defaultReaction="heart"
            popoverTriggerAriaLabel="Reactions"
          />
        </div>
        <div>
          <h2>with heart icon selected</h2>
          <Reactions
            selectedId="thinking"
            onReactionSelect={() => {}}
            additionalReactions={heartItems}
            reactionIcon={(id) => heartItemsData[id].icon}
            reactionLabel={(id) => heartItemsData[id].label}
            defaultReaction="heart"
            popoverTriggerAriaLabel="Reactions"
          />
        </div>
        <div>
          <h2>with thumbs up icon</h2>
          <Reactions
            onReactionSelect={() => {}}
            additionalReactions={thumbsupItems}
            reactionIcon={(id) => thumbsUpItemsData[id].icon}
            reactionLabel={(id) => thumbsUpItemsData[id].label}
            defaultReaction="thumbsup"
            popoverTriggerAriaLabel="Reactions"
          />
        </div>
        <div>
          <h2>with thumbs up icon selected</h2>
          <Reactions
            selectedId="clap"
            onReactionSelect={() => {}}
            additionalReactions={thumbsupItems}
            reactionIcon={(id) => thumbsUpItemsData[id].icon}
            reactionLabel={(id) => thumbsUpItemsData[id].label}
            defaultReaction="thumbsup"
            popoverTriggerAriaLabel="Reactions"
          />
        </div>
      </EditorShell>,
    );
  });
});
